import React, { cloneElement, MouseEventHandler } from "react";
import classNames from 'classnames';
import * as classes from './Form.css';
// import {Box, Stack} from '@fastlooptech/layout-components';
import { Icon } from "../Icons/Icon";
import IconSet from "../Icons/IconSet";
import BaseTypography from "@/client/foundations/Typography/BaseTypography";
import Button from "../Button";
import { Box, Stack } from "@/layouts/LayoutComponents";
import Spinner from "@/components/Spinner";
// import {Button} from "@/client/presentation/components/Button/Button";
// import BaseTypography from "@/client/presentation/foundations/Typography/BaseTypography";
// import {Icon} from "@/client/presentation/components/Icons/Icon";
// import IconSet from "@/client/presentation/components/Icons/IconSet";

export enum FORMSTATUSENUM {
  "Empty", "Dirty", "Warning", "Error", "Success"
}

export type FormProps = {
  'data-test-id'?: string;
  /**
   * The id of the form.
   * @type string
   * @required
   */
  id: string;
  /**
   * The content of the form.
   * @type string | JSX.Element;
   * @required
   */
  children: React.JSX.Element;
  /**
   * The disabled state of the form.
   * @default false
   * @type boolean
   */
  disabled?: boolean;
  /**
   * The action of the form.
   * @type MouseEventHandler<HTMLButtonElement>
   * @default () => {}
   */
  action?: MouseEventHandler<HTMLButtonElement>;
  /**
   * A label for screen readers
   * @type string
   */
  'aria-label'?: string;
  /**
   * The form name
   * @type string
   */
  name?: string;
  /**
   * CSS className
   * @type string
   */
  className?: string;
  /**
   * The status of the form.
   * @type MouseEventHandler<HTMLButtonElement>
   * @default "Empty"
   */
  status?: string | "Empty" | "Dirty" | "Warning" | "Error" | "Success" | "Loading";
  /**
   * The status message of the form.
   * @type MouseEventHandler<HTMLButtonElement>
   */
  statusMessage?: string;
  /**
   * The label of the form submit button.
   * @type MouseEventHandler<HTMLButtonElement>
   */
  submitLabel?: string;
  /**
   * The form is in a modal that needs max heigh.
   * @type boolean
   */
  inModal?: boolean;
}

export function Form(props: FormProps) {
  const onSubmit = (event: any): void => {
    event.preventDefault();
    event.stopPropagation();
    if (props.action) {
      props.action(event);
    }
  }

  return (
    <Box
      component="form"
      id={props.id}
      aria-label={props['aria-label']}
      data-test-id={props['data-test-id']}
      type="form"
      className={classNames(
        props.className
      )}
      disabled={props.disabled}
      onSubmit={onSubmit}
      name={props.name}
      column
      autoFocus={false}
    >
      {/* <pre>Outside stack ---- </pre> */}
      <Stack vAlignContent="center" hAlignContent="left" gap={8} column
        className={props.inModal ? "max-h-[400px]" : ""}>
        {props.status === 'Loading' ? (
          <Box className="w-full" hAlignContent={"center"}>
            <div className="border-interactive-pink h-3 w-3 animate-spin rounded-full border-4 border-t-base-dark-grey" />
            <Spinner skipTimer={true} loading={props.status === 'Loading' ? true : false} loadingText="Sending message..." style={{ position: "absolute" }} />
            {/* <span className="">Sending message...</span> */}
          </Box>
        ) : (cloneElement(props.children, {
          id: 'form-fields-' + props.id,
          className: classNames(
            props.children.props.className
          ),
        })
        )}

        {/* <pre>{JSON.stringify(props?.status)}</pre> */}

        {(props.status === "Success" || props.status === "Warning" || props.status === "Error") ?
          <div className={classNames(
            'flex gap-2 items-center',
            classes.feedbackVariants[props.status]
          )}>
            <Icon id="success-icon" size="s" className={classNames(classes.feedbackIconVariants[props.status])}>
              {IconSet[props.status]}
            </Icon>
            <BaseTypography component="p" role="none">
              {props.statusMessage ||
                (props.status === "Success" ? "Request sent successfully" :
                  (props.status === "Warning" ? "Please Check the entered data" :
                    (props.status === "Error" ? "Error occurs. Please try again later" : "")
                  )
                )
              }
            </BaseTypography>
          </div> : null}

        {/* <pre>Inside stack ---- </pre> */}

        <div className={"pb-5"}>
          {(!props.status || props.status === "Dirty" || props.status === "Empty" || props.status === "Warning" || props.status === "Error") ?
            <Button id={props.inModal ? "modal-submit-button" : "submit-button"} size="m" variant="primary"
              type="submit">
              {props.submitLabel || 'Submit'}
            </Button> : null
          }
        </div>
      </Stack>
    </Box>
  );
}